import {ReactElement, memo} from "react";
import {SvgType} from 'constant/interfaces';

const PastIcon = (props:SvgType):ReactElement  => {
	return (
		<svg {...props} height="20px" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="20px" xmlns="http://www.w3.org/2000/svg">
			<path d="M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z"/>
			<path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10"/>
			<path d="m17 10 4 4-4 4"/>
		</svg>
	)
}

const PastIconMemo = memo(PastIcon);
export default PastIconMemo;